import { instanceWithV2 as instance } from './SimpleAPIClient';
import CONFIG from '../config/config';
import { CommissionContractTemplate } from '../types/commissionContract';
import { CommissionComment } from './ComissionContractsAPI';

interface CommissionContractInfo {
    storeInfo: {
        logoUrl?: string;
        brandName?: string;
        companyName?: string;
        companyAddress?: string;
        deliveryAddress?: string;
        phoneNumber?: string;
        email?: string;
        instagram?: string;
        country?: string;
        currency?: string;
    };
    template: CommissionContractTemplate;
}

interface CommissionContractResponse {
    id?: number;
    brideName: string;
    brideSurname: string;
    bridePhone: string;
    brideEmail: string;
    brideSocial: string;
    dress: string;
    dressSize: string;
    purchaseYear: string;
    purchasePriceAmount?: number;
    purchasePriceCurrency?: string;
    desiredSalePriceAmount?: number;
    desiredSalePriceCurrency?: string;
    damagesNotes?: string;
    notes?: string;
    addons?: Addon[];
    status: string;
    acceptedDate: string;
    endDate: string;
    payment: string;
    pdf?: string;
    attachments?: string[];
    trackingId?: string;
    locale?: string;
    submissionDate?: string;
    storeInfo?: {
        logoUrl?: string;
        brandName?: string;
        companyName?: string;
        companyAddress?: string;
        deliveryAddress?: string;
        phoneNumber?: string;
        email?: string;
        instagram?: string;
        country?: string;
        currency?: string;
    };
    itemReceived: boolean;
    salonSplitPercentage?: number;
    brideSplitPercentage?: number;
    onlinePaymentsEnabled?: boolean;
    contractNumber?: string;
    contractReference?: string;
    paymentPlan?: {
        id: number;
        resourceId: string;
        totalAmount: number;
        currency: string;
        description?: string;
        status: string;
        paymentSplits: Array<{
            id: number;
            amount: number;
            dueDate: string;
            paymentMethod: string;
            paid: boolean;
            paidDate?: string;
            invoiceReference?: string;
            concept?: string;
            description?: string;
            validForDays?: number;
            isDisabled?: boolean;
            updatedAt: string;
        }>;
    };
}

interface CommissionContractSubmit {
    brideName: string;
    brideSurname: string;
    bridePhone: string;
    brideEmail: string;
    brideSocial: string;
    dress: string;
    dressSize: string;
    purchaseYear: string;
    purchasePriceAmount: number;
    purchasePriceCurrency: string;
    desiredSalePriceAmount: number;
    desiredSalePriceCurrency: string;
    damagesNotes?: string;
    addons?: Addon[];
    notes?: string;
    attachments?: string[];
    locale?: string;
}

interface Addon {
    name: string;
    description: string;
    cost: number;
    currency: string;
}

const CommissionContractAPI = {
    getContractInfo: (alias: string, locale: string) => 
        instance(CONFIG.API_ENDPOINT).get<CommissionContractInfo>(`v1/public/commission-contracts/${alias}`, {
            params: { locale }
        }),

    submitContract: (alias: string, contract: CommissionContractSubmit, locale: string) =>
        instance(CONFIG.API_ENDPOINT).post(`v1/public/commission-contracts/${alias}/submit`, contract, {
            params: { locale }
        }),

    getContractByTrackingId: (trackingId: string) =>
        instance(CONFIG.API_ENDPOINT).get<CommissionContractResponse>(`v1/public/commission-contracts/tracking/${trackingId}`),

    getPublicComments: (trackingId: string) =>
        instance(CONFIG.API_ENDPOINT).get<CommissionComment[]>(`v1/public/commission-contracts/tracking/${trackingId}/comments`),

    addPublicComment: (trackingId: string, comment: { comment: string }) =>
        instance(CONFIG.API_ENDPOINT).post<CommissionComment>(`v1/public/commission-contracts/tracking/${trackingId}/comments`, comment),

    downloadPDF: (trackingId: string) =>
        instance(CONFIG.API_ENDPOINT).get(`v1/public/commission-contracts/tracking/${trackingId}/pdf`, {
            responseType: 'blob'
        }),

    updateContract: (trackingId: string, contract: CommissionContractSubmit) =>
        instance(CONFIG.API_ENDPOINT).put<CommissionContractResponse>(`v1/public/commission-contracts/tracking/${trackingId}`, contract)
};

export default CommissionContractAPI; 